import React, { useState, useEffect } from "react";

const randomOperator = () => {
  const operators = ["+", "-", "*", "/"];
  return operators[Math.floor(Math.random() * operators.length)];
};

const generateEquation = () => {
    const num1 = Math.floor(Math.random() * 10) + 1; // Random number 1-10
    const num2 = Math.floor(Math.random() * 10) + 1; // Random number 1-10
    const operator = randomOperator();

    let result = 0;
    let equation = "";

    switch (operator) {
        case "+":
            {
                result = num1 + num2;
                equation = `${num1} + ${num2}`;
            }
            break;
        case "-":
            {
                // Ensure non-negative results for subtraction
                if (num1 >= num2) {
                    result = num1 - num2;
                    equation = `${num1} - ${num2}`;
                } else {
                    result = num2 - num1;
                    equation = `${num2} - ${num1}`;
                }
            }
            break;
        case "*":
            {
                result = num1 * num2;
                equation = `${num1} * ${num2}`;
            }
            break;
        case "/":
            {
                // Ensure whole number results for division
                const divisor = Math.floor(Math.random() * 9) + 1; // Divisor 1-9
                const dividend = divisor * Math.floor(Math.random() * 10); // Multiple of divisor
                result = dividend / divisor;
                equation = `${dividend} / ${divisor}`;
            }
            break;
        default:
            break;
    }

    return { equation, result };
};




const GreaterLessThanHard: React.FC = () => {
    const [question, setQuestion] = useState<any>(null);
    const [showImage, setShowImage] = useState(false);
    const [error, setError] = useState(false);

    const generateQuestion = () => {
        const eq1 = generateEquation();
        const eq2 = generateEquation();

        setQuestion({
            equation1: eq1.equation,
            equation2: eq2.equation,
            result1: eq1.result,
            result2: eq2.result,
        });

    };

    const checkAnswer = (operator: string) => {
        if (!question) return;

        let correctOperator;
        if (question.result1 > question.result2) {
            correctOperator = ">";
        } else if (question.result1 < question.result2) {
            correctOperator = "<";
        } else {
            correctOperator = "=";
        }

        if (operator === correctOperator)
        {
            setShowImage(true);
            setTimeout(() => {
                generateQuestion();
                setShowImage(false);
                setError(false);
            }, 5000);
        } else {
            setError(true);
        }
    };

  useEffect(() => {
    generateQuestion();
    document.title = "Mamas Guidance - Class Two - Mathematics - Greater Than / Less Than - Hard"; // Set page title
  }, []);

    return (
        <>
            {
                showImage === false ?
                <>
                    <div className='contentPart showMiddle'>
                        <div className="worksheet-container">
                            {question && (
                                <div className="grid-container question-list">
                                    <div className="grid-box d-none d-md-block"></div>
                                    <div className="grid-box grid-container-second">
                                        <div className="grid-box">{question.equation1}</div>
                                        <div className="grid-box mb-2">
                                            <input
                                                type="text"
                                                placeholder="?"
                                                readOnly
                                                className={`form-control blank-input ${error == true  ? 'error' : ''} `}
                                                />
                                        </div>
                                        <div className="grid-box">{question.equation2}</div>
                                    </div>
                                    <div className="grid-box d-none d-md-block"></div>
                                </div>
                            )}
                            <div className="optionDiv mt-4 text-center" style={{marginLeft:0}}>
                                <div className="optionButton" onClick={() => checkAnswer(">")}>&gt;</div>
                                <div className="optionButton" onClick={() => checkAnswer("<")}>&lt;</div>
                                <div className="optionButton" onClick={() => checkAnswer("=")}>=</div>
                            </div>
                        </div>
                    </div>
                </>
                :
                <>
                    <div className="contentPart showMiddle">
                        <img style={{height: '150px'}} className='img-fluid' src={process.env.REACT_APP_WELDONE_LINK} />
                    </div>
                </>
                }
        </>
    );
};


export default GreaterLessThanHard;
